import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Dropdown, Grid, Icon } from "~/components-shared";
import { useDispatch } from "react-redux";
import styled, { useTheme } from "styled-components";
import TopicFootprintLabels from "~/components/TopicFootprintLabels";
import topicFootprintActionCreators from "~/store/topicFootprints/actions";
import { CRUDActionEnum, TopicFootprintSourceEnum } from "~/types/enums";
import mixpanel from "mixpanel-browser";
const NoteCount = styled.div`
  position: absolute;
  background-color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.note.main;
}};
  border-radius: 50%;
  min-width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.note.text;
}};
  font-size: 10px;
  font-weight: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.typography.fontWeight.bold;
}};
  top: -4px;
  right: -5px;
  transition: transform 300ms ease-in-out;
  box-shadow: 0 0 0 2px ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.background.primary;
}};
  ${_ref5 => {
  let {
    count
  } = _ref5;
  return count <= 0 && "transform: scale(0)";
}}
`;
const TopicFootprintActions = _ref6 => {
  let {
    topicId,
    footprint,
    openNotes,
    onOpenNotes
  } = _ref6;
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const handleToggleStar = () => {
    dispatch(topicFootprintActionCreators.starStarted(topicId, footprint.id));
    mixpanel.track(`Topic Footprint – Star`, {
      footprintId: footprint.id
    });
  };
  const handleDelete = () => {
    dispatch(topicFootprintActionCreators.actionChanged(CRUDActionEnum.DELETE, footprint.id, topicId));
    mixpanel.track(`Topic Footprint – Delete`, {
      footprintId: footprint.id
    });
  };
  const handleEdit = () => {
    dispatch(topicFootprintActionCreators.actionChanged(CRUDActionEnum.UPDATE, footprint.id, topicId));
    mixpanel.track(`Topic Footprint – Edit`, {
      footprintId: footprint.id
    });
  };
  return /*#__PURE__*/React.createElement(Grid, {
    className: "topic__footprint-actions",
    cols: 4,
    gap: 1,
    template: "2.3rem 2.3rem 2.3rem 2.3rem",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(TopicFootprintLabels, {
    topicId: topicId,
    footprint: footprint
  }), /*#__PURE__*/React.createElement(Button, {
    color: footprint.notes.length ? "note" : "transparent",
    onClick: () => onOpenNotes(footprint.id),
    s: {
      p: 2,
      mt: 2
    },
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": t("TopicFootprint.notes"),
    outline: openNotes
  }, /*#__PURE__*/React.createElement(NoteCount, {
    count: footprint.notes.length || 0
  }, footprint.notes.length && footprint.notes.length > 9 ? "9+" : footprint.notes.length || 0), /*#__PURE__*/React.createElement(Icon, {
    src: "notes",
    display: "block",
    color: "inherit"
  })), /*#__PURE__*/React.createElement(Button, {
    color: footprint.starred ? "note" : "transparent",
    onClick: handleToggleStar,
    s: {
      p: 2,
      mt: 2
    },
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": t("TopicFootprint.star")
  }, /*#__PURE__*/React.createElement(Icon, {
    src: footprint.starred ? "starFill" : "star",
    display: "block",
    color: "inherit"
  })), /*#__PURE__*/React.createElement(Dropdown, {
    direction: "bottomLeft",
    handlerProps: {
      s: {
        p: 2,
        mt: 2
      },
      "data-tooltip-id": "general-tooltip",
      "data-tooltip-content": t("common.actions.options")
    },
    handler: /*#__PURE__*/React.createElement(Icon, {
      src: "dots-vertical",
      display: "block",
      color: colors.text.primary
    })
  }, _ref7 => {
    let {
      isOpen,
      onItemClick
    } = _ref7;
    return /*#__PURE__*/React.createElement(Dropdown.List, {
      isOpen: isOpen
    }, footprint.source === TopicFootprintSourceEnum.JOYN && /*#__PURE__*/React.createElement(Dropdown.ListItem, {
      onClick: () => {
        onItemClick();
        handleEdit();
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      src: "pencil",
      scale: 4.5,
      s: {
        mr: 2
      },
      color: "primary"
    }), t("common.actions.edit")), /*#__PURE__*/React.createElement(Dropdown.ListItem, {
      onClick: () => {
        onItemClick();
        handleDelete();
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      src: "bin",
      scale: 4.5,
      s: {
        mr: 2
      },
      color: "danger"
    }), t("common.actions.delete")));
  }));
};
export default TopicFootprintActions;